import { render, staticRenderFns } from "./StatusPopover.vue?vue&type=template&id=60dc114a&scoped=true"
import script from "./StatusPopover.vue?vue&type=script&lang=js"
export * from "./StatusPopover.vue?vue&type=script&lang=js"
import style0 from "./StatusPopover.vue?vue&type=style&index=0&id=60dc114a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dc114a",
  null
  
)

export default component.exports